<template>
  <header class="tx-board-header">
    <div class="tx-board-header__identity">
      <strong>
        <!-- <span class="tx-board-header__table-code">{{ table.code }} -</span> -->
        <span class="tx-board-header__table-id">{{ useName ? table.name || table.code : table.code }} #{{ table.round }}</span>
      </strong>
    </div>

    <TaiXiuDiceRow
      class="tx-board-header__dice"
      :table="table"
      :is-rolling="isRolling"
      :float-result="floatResult"
    />

    <!-- <div class="tx-board-header__actions">
      <div class="tx-board-header__timer" :class="{ closing: table.secondsRemaining <= 5 }">
        00:{{ paddedSeconds }}s
      </div>
    </div> -->
  </header>
</template>

<script>
import TaiXiuDiceRow from '@/components/tai-xiu/tai-xiu-dice-row.vue';

/*
 * The bar under the Tài Xỉu video: table code and round on the left, the result
 * dice centred in their pill, the countdown on the right.
 *
 * Extracted from tai-xiu-full-board-top.vue so the desktop pane shows the same
 * bar rather than a second, thinner imitation of it -- the desktop version had
 * drifted to bare dice with no pill and no gradient.
 */
export default {
  name: 'TaiXiuBoardHeader',
  components: {
    TaiXiuDiceRow,
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    isRolling: {
      type: Boolean,
      default: false,
    },
    // Mobile has room for the arena's name; desktop shows its short code.
    useName: {
      type: Boolean,
      default: false,
    },
    // The result appears beside the dice rather than widening the pill they sit in.
    floatResult: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    paddedSeconds() {
      return `0${this.table.secondsRemaining || 0}`.slice(-2);
    },
  },
};
</script>

<style lang="scss" scoped>
.tx-board-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  // v2.1: the 28px bar under the video (the desktop panes make it 34).
  height: 28px;
  min-height: 28px;
  padding: 0 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-sizing: border-box;
  background: $ga-info-bar-bg;
}

.tx-board-header__identity {
  position: relative;
  z-index: 1;
  min-width: 0;
  flex: 0 1 auto;

  strong {
    display: flex;
    gap: 4px;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
  }
}

.tx-board-header__table-code,
.tx-board-header__table-id  {
  color: #fff;
}

.tx-board-header__dice {
  // Positioning only; the dice and their animation live in tai-xiu-dice-row.vue.
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 0;
  width: auto;
  min-width: 76px;
  height: 22px;
  white-space: nowrap;
  padding: 0 8px;
  border-radius: 999px;
  border: 0;
  background-color: $ga-dice-pill-bg;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
  pointer-events: none;

  // The dice fill the pill (PO feedback: as big as the bar allows).
  ::v-deep .tx-die {
    width: 16px;
    height: 16px;
  }
}

.tx-board-header__actions {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 11px;
  flex: 0 0 auto;
  margin-left: auto;
}

.tx-board-header__timer {
  color: #efc87f;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;

  &.closing {
    color: #fa6f6f;
  }
}

@media screen and (max-width: 360px) {
  .tx-board-header__identity strong {
    font-size: 12px;
  }

  .tx-board-header__dice {
    width: auto;
    min-width: 108px;
    gap: 4px;
    padding-right: 8px;
    padding-left: 8px;

    ::v-deep .tx-die {
      width: 26px;
      height: 26px;
    }
  }
}
</style>
